export enum SearchType {
    MyUnits = "myUnits",
    MyTeam = "myTeam",
    Email = "assigneeEmail",
    Code = "code",
}

export enum SearchStage {
    onboarding = "onboarding",
    live = "live",
}

export type SelectedSearchStage = SearchStage
